const NCOB_TYPE_TIME = Object.freeze({
  none: '00:00:00',
  oneDay: '24:00:00',
  twoDays: '48:00:00',
  threeDays: '72:00:00',
});

export default NCOB_TYPE_TIME;
